// extracted by mini-css-extract-plugin
module.exports = {"filterChip":"GeneralInfoSection_filterChip__jMTyO","filterCustomer":"GeneralInfoSection_filterCustomer__3QlMa","suggestedDelivery":"GeneralInfoSection_suggestedDelivery__3bgG3"};